const ROUTES = {
  home: '/',
  treatments: '/tratamientos',
  aestheticTreatments: '/estetica-avanzada',
  shop: 'https://shop.holaglow.com',
  longevityTreatments: '/longevidad',
  aestheticMultistep: {
    start: '/estetica-avanzada/multistep/start',
    concerns: '/estetica-avanzada/multistep/concerns',
    skinType: '/estetica-avanzada/multistep/skin-type',
    makeUp: '/estetica-avanzada/multistep/makeUp',
    skinSensibility: '/estetica-avanzada/multistep/skin-sensitivity',
    routineProducts: '/estetica-avanzada/multistep/routine-products',
    gender: '/estetica-avanzada/multistep/gender',
    lactating: '/estetica-avanzada/multistep/lactancy',
    age: '/estetica-avanzada/multistep/age',
    extraInfo: '/estetica-avanzada/multistep/extra-info',
    form: '/estetica-avanzada/multistep/form',
    thankYou: '/estetica-avanzada/multistep/thank-you',
  },
  reagenda: '/reagenda',
  checkout: {
    clinics: '/checkout/clinicas',
    type: '/checkout/tipo-cita',
    payment_type: '/checkout/tipo-pago',
    treatments: '/checkout/treatments',
    schedule: '/checkout/agenda',
    contactForm: '/checkout/contactform',
    confirmation: '/checkout/confirmation',
    start: '/checkout/start',
    startBlackFriday: '/checkout/startblackfriday',
  },
  clinics: '/clinica-medicina-estetica',
  aboutUs: '/quienes-somos',
  blog: '/blog',
  dashboard: {
    home: '/dashboard',
    vouchers: '/dashboard/vouchers',
    login: '/dashboard/login',
    crisalix: '/dashboard/crisalix',
    menu: '/dashboard/menu',
    agenda: '/dashboard/agenda',
    reagenda: '/dashboard/reagenda',
    moduleSelector: '/dashboard/moduleSelector',
    users: '/dashboard/users',
    checkOut: '/dashboard/checkout',
    forms: '/dashboard/forms',
    invoices: '/dashboard/invoices',
    checkIn: {
      treatments: '/dashboard/checkin/treatments',
      agenda: '/dashboard/checkin/agenda',
      thankYou: '/dashboard/checkin/welcome',
      contactForm: '/dashboard/checkin/treatments',
      badRequest: '/dashboard/checkin/badRequest',
      confirmation: '/dashboard/checkin/confirmation',
    },
    schedule: '/dashboard/schedule',
    budgets: '/dashboard/budgets',
    documents: '/dashboard/documents',
    allBudgets: '/dashboard/all-budgets',
    trainnings: '/dashboard/trainnings',
    userBudgets: '/dashboard/user-budgets',
    comments: '/dashboard/comments',
    dashboardJobs: '/dashboard/dashboardJobs',
    dashboardNews: '/dashboard/dashboardNews',
    sales: '/dashboard/sales',
    surveyMultistep: {
      start: '/dashboard/encuesta/start',
      discover: '/dashboard/encuesta/discover',
      nationality: '/dashboard/encuesta/nationality',
      birthday: '/dashboard/encuesta/birthday',
      postalCode: '/dashboard/encuesta/postal-code',
      apprehensive: '/dashboard/encuesta/apprehensive',
      gender: '/dashboard/encuesta/gender',
      smoker: '/dashboard/encuesta/smoker',
      lactating: '/dashboard/encuesta/lactancy',
      herpes: '/dashboard/encuesta/herpes',
      routineProducts: '/dashboard/encuesta/routine-products',
      lastHygiene: '/dashboard/encuesta/last-hygiene',
      previousTreatments: '/dashboard/encuesta/previous-treatments',
      lastTreatment: '/dashboard/encuesta/last-treatment',
      extraInfo: '/dashboard/encuesta/extra-info',
      thankYou: '/dashboard/encuesta/thank-you',
      commercialCheck: '/dashboard/encuesta/commercialcheck',
    },
  },
  statics: {
    termsAndConditions: '/aviso-legal',
    privacyPolicy: '/politica-de-privacidad',
    medicDirector: '/director-medico',
  },
  landings: {
    pv: '/start-landing',
    aesthetic: '/estetica-avanzada/start-landing',
    longevity: '/longevidad/start-landing',
  },
  hair: {
    home: '/hair',
    multistep: {
      start: '/hair/multistep/start',
      since: '/hair/multistep/since',
      area: '/hair/multistep/area',
      symptoms: '/hair/multistep/symptoms',
      previousTreatments: '/hair/multistep/previous-treatments',
      age: '/hair/multistep/age',
      allergy: '/hair/multistep/allergy',
      medication: '/hair/multistep/medication',
      previousIllness: '/hair/multistep/previous-illness',
      paternity: '/hair/multistep/paternity',
      extraInfo: '/hair/multistep/extra-info',
      agenda: '/hair/multistep/agenda',
    },
  },
  derma: {
    home: '/',
    precios: '/precios',
    clinics: '/clinicas',
    aboutUs: '/quienes-somos',
    privacyPolicy: '/politica-de-privacidad',
    termsAndConditions: '/aviso-legal',
    multistep: {
      start: '/multistep/start',
      pains: '/multistep/pains',
      symptoms: '/multistep/symptoms',
      skinType: '/multistep/skin-type',
      skinSensibility: '/multistep/skin-sensitivity',
      skinColor: '/multistep/skin-color',
      secondaryConcern: '/multistep/secondary-concern',
      allergy: '/multistep/allergy',
      illness: '/multistep/illness',
      medication: '/multistep/medication',
      lactating: '/multistep/lactancy',
      gender: '/multistep/gender',
      age: '/multistep/age',
      routine: '/multistep/routine',
      routineProducts: '/multistep/routine-products',
      routineTime: '/multistep/routine-time',
      sunScreen: '/multistep/sunscreen',
      pictures: '/multistep/pictures',
      extraInfo: '/multistep/extra-info',
      form: '/multistep/form',
      payment: '/multistep/payment',
      thankyou: '/multistep/thank-you',
      planes: '/multistep/planes',
      output: {
        pain: '/multistep/output-pain',
        skinType: '/multistep/output-skin-type',
        skinColor: '/multistep/output-skin-color',
        secondaryConcern: '/multistep/output-secondary-concern',
        skinCare: '/multistep/output-skin-care',
        pictures: '/multistep/output-pictures',
      },
    },
    diagnostico: {
      home: '/diagnostico',
      seguimiento: '/diagnostico/seguimiento',
      subscription: '/diagnostico/subscription',
    },
  },
  glowbox: {
    home: '/glowbox',
    experiences: '/glowbox/experiencias',
  },
  user: {
    budget: '/user/budget',
    invoices: '/user/invoice',
    beautyPass: '/user/passport',
    medicalCertificate: '/user/medical-certificate',
  },
};

export default ROUTES;
